/*
 * @Author: wxb
 * @Date: 2022-04-12 13:49:24
 * @LastEditors: wxb
 * @LastEditTime: 2022-04-12 13:49:25
 * @Description:
 */
import Vue from 'vue'
export default new Vue()
